import MidiEffect from './MidiEffect.js';
import {mod} from "utils/mod.js";
import NodeMessaging from "messaging/NodeMessaging.js";
import MidiTrigger from './MidiTrigger.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import Tone from 'tone';

class NoteDisplay extends NodeMessaging(MidiEffect) {
    constructor(track) {
        super('Note Display', track);

        // all it does is keep track of notes that are playing
        this.notes = {};
        this.timeOn = {};
        this.durations = {};
        this.velocities = {};
        this.newOutlet("notes on");
        this.newOutlet("note durations");
   }

    removeNote(note, sliceNumber, skip=!this.gated) {
        delete this.notes[note];
    }
    
    output(time) {
        for (let note in this.notes) {
            this.notes[note]--;
            if (this.notes[note] <= 0) {
                delete this.notes[note];
            }
        }
        for (let trigger of this.triggers) {
            if (!trigger.stepData) {
                continue;
            }
            let {transpose, duration, velocity} = trigger.stepData;

            // when we get a trigger we put the lenght of its duration in the notes object
            this.notes[transpose] = duration*2;
            this.durations[transpose] = duration;
            this.velocities[transpose] = velocity;
            this.timeOn[transpose] = time;
        }
        this.sendMessage("notes on", Object.keys(this.notes));
        let _notes = new Array(12).fill(0);
        for (let note in this.notes) {
            let _note = mod(parseInt(note), 12);
            _notes[_note] = this.notes[note];
            let dur = this.durations[note];
            let vel = this.velocities[note];
            _notes[_note] = vel * 3.*this.notes[note] / dur;

            let timeOn = this.timeOn[note];
            if (Math.pow(time - timeOn, 3.) < _notes[_note]) {
                _notes[_note] = Math.pow((time - timeOn), 3);
            }
        }
        this.sendMessage("note durations", _notes);
        return this.triggers;
    }

    stop() {
        this.notes = {};
    }

    getCopy(track, ignoreId=true) {
        let fx = new NoteDisplay(track);
        fx.fromJson(this.getJson(), ignoreId);
        return fx;
    }
}

export default NoteDisplay;
